import { jsx } from 'react/jsx-runtime';
import { css } from '@flex-design-system/stitches-react';
import cx from 'classnames';
import { forwardRef, useMemo, useState, useEffect, Suspense } from 'react';
import { EmojiImageSize } from '../constants.mjs';
import useEmojis from '../hooks/useEmojis.mjs';
import { getEmojiCodeFromEmoji, getSourcePathFromCode, getEmojiFromEmojiId } from '../utils.mjs';

const DEFAULT_EMOJI_SIZE = 24;
const FALLBACK_EMOJI_CODE = "1f5d2-fe0f";
const EmojiView = forwardRef(
  (props, ref) => {
    const {
      size = DEFAULT_EMOJI_SIZE,
      className,
      style,
      ...imageProps
    } = props;
    const { data } = useEmojis({ suspense: true });
    const emojiImageSize = size > 32 ? EmojiImageSize.Large : EmojiImageSize.Small;
    const codeFromProps = useMemo(() => {
      if (props.emojiId !== void 0) {
        if (data === void 0) {
          return FALLBACK_EMOJI_CODE;
        }
        const emoji = getEmojiFromEmojiId(data, props.emojiId);
        if (emoji === void 0) {
          return FALLBACK_EMOJI_CODE;
        }
        return getEmojiCodeFromEmoji(emoji);
      }
      return props.code;
    }, [data, props]);
    const alt = useMemo(() => {
      try {
        return String.fromCodePoint(Number.parseInt(codeFromProps, 16));
      } catch {
        return "emoji";
      }
    }, [codeFromProps]);
    const [emojiCode, setEmojiCode] = useState(codeFromProps);
    useEffect(() => {
      setEmojiCode(codeFromProps);
    }, [codeFromProps]);
    return /* @__PURE__ */ jsx(
      "img",
      {
        ref,
        alt,
        ...imageProps,
        style: {
          width: size,
          height: size,
          ...style
        },
        className: cx(className, emojiStyle()),
        src: getSourcePathFromCode(emojiCode, emojiImageSize),
        onError: () => {
          setEmojiCode(FALLBACK_EMOJI_CODE);
        }
      }
    );
  }
);
const EmojiViewWithSuspense = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    Suspense,
    {
      fallback: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            width: props.size,
            height: props.size
          },
          className: emojiStyle()
        }
      ),
      children: /* @__PURE__ */ jsx(EmojiView, { ...props, ref })
    }
  );
});
const emojiStyle = css({
  display: "block"
});

export { EmojiViewWithSuspense as default };
//# sourceMappingURL=index.mjs.map
